import { assignSafe } from './functions/assign-safe';

export class ValidationMessage {
  type: 'required' | 'min' | 'max' | 'minlength' | 'pattern' | 'nullValidator' | string;
  custom?: boolean;
  parameter?: number | RegExp;
  message: string;

  constructor(jsonData?: Partial<ValidationMessage>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
  }
}
